export const fetchLiveHits = async (gamePk) => {
  try {
    const [pbpRes, boxRes] = await Promise.all([
      fetch(`https://statsapi.mlb.com/api/v1/game/${gamePk}/playByPlay`),
      fetch(`https://statsapi.mlb.com/api/v1/game/${gamePk}/boxscore`),
    ]);
    const playByPlay = pbpRes.ok ? await pbpRes.json() : null;
    const boxScore = boxRes.ok ? await boxRes.json() : null;
    return { playByPlay, boxScore };
  } catch {
    return { playByPlay: null, boxScore: null };
  }
};

export const parseHits = (allPlays = []) => {
  const HIT_EVENTS = ['Single', 'Double', 'Triple', 'Home Run'];
  return allPlays
    .filter(p => HIT_EVENTS.includes(p.result?.event))
    .map(p => ({
      batter: p.matchup?.batter?.fullName || '--',
      batterId: p.matchup?.batter?.id,
      pitcher: p.matchup?.pitcher?.fullName || '--',
      pitcherId: p.matchup?.pitcher?.id,
      event: p.result?.event,
      description: p.result?.description || '',
      inning: p.about?.inning,
      isTop: p.about?.isTopInning,
      rbi: p.result?.rbi || 0,
      homeScore: p.about?.homeScore ?? 0,
      awayScore: p.about?.awayScore ?? 0,
      pitchSpeed: p.pitchIndex != null
        ? p.playEvents?.find(e => e.isPitch)?.pitchData?.startSpeed
        : null,
      exitVelocity: p.playEvents?.slice().reverse()
        .find(e => e.hitData?.launchSpeed)?.hitData?.launchSpeed || null,
      launchAngle: p.playEvents?.slice().reverse()
        .find(e => e.hitData?.launchAngle)?.hitData?.launchAngle || null,
      distance: p.playEvents?.slice().reverse()
        .find(e => e.hitData?.totalDistance)?.hitData?.totalDistance || null,
      hardness: p.playEvents?.slice().reverse()
        .find(e => e.hitData?.hardness)?.hitData?.hardness || null,
    }));
};

export const parsePlayerHitLines = (boxScore) => {
  if (!boxScore) return { away: [], home: [] };
  const extract = (side) => {
    const players = Object.values(boxScore.teams?.[side]?.players || {});
    return players
      .filter(p => p.stats?.batting?.atBats > 0)
      .map(p => ({
        id: p.person?.id,
        name: p.person?.fullName || '--',
        pos: p.position?.abbreviation || '--',
        ab: p.stats.batting.atBats,
        h: p.stats.batting.hits,
        hr: p.stats.batting.homeRuns || 0,
        rbi: p.stats.batting.rbi || 0,
        bb: p.stats.batting.baseOnBalls || 0,
        k: p.stats.batting.strikeOuts || 0,
        avg: p.stats.batting.atBats > 0
          ? (p.stats.batting.hits / p.stats.batting.atBats).toFixed(3).replace('0.', '.')
          : '.000',
      }))
      .sort((a, b) => b.h - a.h);
  };
  return { away: extract('away'), home: extract('home') };
};